<template>
  <div>
    <parent
      :pageStack="pageStack"
      @push-page="pushPage"
      @pop-page="popPage"
      @fetchData="fetchData"
      @refreshContent="getContentsOfFiles">
    </parent>

    <div id="loader" v-show="showLoader">
      <i class="fa fa-spinner fa-spin"></i><br>
      {{ loadingMessage }}
    </div>
  </div>
</template>

<script>
import { global } from './global.js'
import { helpers } from './helpers.js'
import { appData } from './data.js'
import { locStor } from './localStorageManagement.js'
//import { localResponse } from './response.js'
import 'whatwg-fetch'

switch (global.STYLE) {
  case '1':
    var Landing = require('./Option1/components/Landing').default;
    var Parent = require('./Option1/Parent').default;
    break;
  case '2':
    var Landing = require('./Option2/components/Landing').default;
    var Parent = require('./Option2/Parent').default;
    break;
  case '3':
    var Landing = require('./Option3/components/Landing').default;
    var Parent = require('./Option3/Parent').default;
    break;
}

export default {
  name: 'app',
  components: {
    Parent
  },
  data () {
    return {
      pageStack: [],
      loadingMessage: 'Loading...',
      showLoader: true,
      fileNames: [],
      defaultLastFetched: '1970-01-01'
    }
  },
  methods: {
    pushPage($event) {
      this.currentView = $event.extends.name;
      this.pageStack.push($event);
    },
    popPage($event) {
      //this.currentView = $event.extends.name;
      this.pageStack.pop();
    },
    showLandingPage(component) {
      this.pushPage({
        extends: component,
        onsNavigatorProps: {

        },
        onsNavigatorOptions: {
          animation: 'none'
        }
      });
    },
    toText(response) {
        return response.text()
    },
    errorHandler(reason) {
      alert(`There was an error communicating with the server. (${reason})`);
    },
    fetchData(file, callback) {
        this.fileNames = [file];
        this.getContentsOfFiles(callback);
    },
    getUpdatedFilenames() {
      let lastFetched = locStor.getLastFetched();
      lastFetched = lastFetched ? lastFetched : this.defaultLastFetched;
      this.loadingMessage = 'Loading new content...';

      return fetch(global.API_URL + '&action=getUpdatedFilenames&lastFetched='+lastFetched)
        .then(this.toText)
        .catch(this.errorHandler)
        .then(response => {
          if(response.includes('error')) {
            this.showLoader = false;
            this.errorHandler(response);
          } else {
            return response;
          }
        })
        ;
    },
    getFile(file) {
      return fetch(global.API_URL + '&action=getFile&filename='+ file)
        .then(this.toText)
        .catch(this.errorHandler);
    },
    getContentsOfFiles(callback) {
      this.allEndpointsAreDone = false;

      if(callback) {
          let type = this.fileNames[0].split('.')[0];
          let typeObject = appData.state.types.filter(t => t.id === type)[0];
          if(typeObject) {
              this.loadingMessage = 'Loading ' + typeObject.title + ' products...';
          } else {
              this.loadingMessage = 'Loading ' + type + '...';
          }

      } else {
          let loadingMessages = [
              'Loading corn products...',
              'Loading soybeans products...',
              'Loading alfalfa products...',
              'Loading seed treatment products...',
              'Loading employee directory...',
              'Loading company history...',
              'Loading legal documents...'
          ];
          let index = 0;
          this.messageInterval = setInterval(() => {
              this.loadingMessage = loadingMessages[index];
              if (index === (loadingMessages.length - 1)) {
                  index = 0;
              } else {
                  index++;
              }
          }, 3000);
      }

      this.showLoader = true;
      let promises = [];
      this.fileNames.forEach(file => {
        let promise = this.getFile(file)
          .then(response => {
            if(file === 'Legal.svg') {
              this.saveLegal(response, callback);
            } else if(file === 'History.svg') {
              this.saveCompanyHistory(response, callback);
            } else if(file.includes('Employees')) {
              this.saveDirectory(JSON.parse(response), callback);
            } else {
              let productsToJson = JSON.parse(response);
              this.saveProducts(productsToJson.Details, file, callback);
              this.saveFilters(file, productsToJson.Filters);
            }
          });
        promises.push(promise);
      });
      Promise.all(promises)
        .then(responses => {
          appData.updateUpdateAlert(false);
          if(!callback) {
              this.showLoader = false;
              this.loadingMessage = 'Loading...';
          }
          this.allEndpointsAreDone = true;
          clearInterval(this.messageInterval);
          locStor.saveLastFetched(new Date().toISOString());
        });
    },
    saveFilters(typeName, data) {
      data.id = typeName.split('.')[0];
      appData.resetTypeFilters();
      appData.updateType(data);
      locStor.saveTypes(appData.state.types);
    },
    saveCompanyHistory(data, lastCallback) {
      let appendUrl = (url) => {
        appData.updateCompanyHistory(url);
        if(this.allEndpointsAreDone) {
            this.showLoader = false;
        }
        if(lastCallback) {
            lastCallback();
        }
      };

      helpers.createFile('History.svg', data, appendUrl);
    },
    saveLegal(data, lastCallback) {
      if(this.allEndpointsAreDone) {
          this.loadingMessage = 'Saving legal documents to local storage...';
          this.showLoader = true;
      }

      let appendUrl = (url) => {
        appData.updateLegal(url);
        if(this.allEndpointsAreDone) {
            this.showLoader = false;
        }
        if(lastCallback) {
            lastCallback();
        }
      };

      helpers.createFile('Legal.svg', data, appendUrl);
    },
    saveDirectory(data, lastCallback) {
      let completedFiles = [];

      if(this.allEndpointsAreDone) {
          this.loadingMessage = 'Saving Employees to local storage...';
          this.showLoader = true;
      }

      let callback = () =>{
        appData.updateEmployees(data);
        if(this.allEndpointsAreDone) {
            this.showLoader = false;
        }
        if(lastCallback) {
            lastCallback();
        }
      };

      data.forEach((employee, index) => {
        employee.fileName = 'employee'+index+'.html';

        let appendUrl = (url) => {
          employee.url = url;
          delete employee.Html;
          completedFiles.push(url);
          if(completedFiles.length === data.length) {
            callback();
          }
        };

        helpers.createFile(employee.fileName, employee.Html, appendUrl);
      });
    },
    saveProducts(data, type, lastCallback) {
      data = data.filter(d => !!d.Name.trim());
      type = type.split('.')[0];
      let typeObject = appData.state.types.filter(t => t.id === type)[0];
      if(this.allEndpointsAreDone) {
          this.loadingMessage = 'Saving ' + typeObject.title + ' to local storage...';
          this.showLoader = true;
      }

      let callback = () =>{
        let filterOutOldProductsOfThisType = appData.state.products.filter(p => p.type !== type);
        let combineProductsWithNew = filterOutOldProductsOfThisType.concat(data);
        appData.updateProducts(combineProductsWithNew);
        if(this.allEndpointsAreDone) {
            this.showLoader = false;
        }
        if(lastCallback) {
            lastCallback();
        }
      };

      let detailsDone = false;
      let namesDone = false;
      let favorites = appData.state.products.filter(p => p.fav);
      let favoritesNames = favorites.map(f => f.Name);
      let completedNameFiles = [];
      let completedDetailNameFiles = [];

      data.forEach((product, index) => {
        product.fileDetailsName = 'product-'+type+'-'+index+'.svg';
        product.fileNameName = 'productname-'+type+'-'+index+'.svg';
        product.type = type;
        product.fav = false;

        if(appData.state.products.length > 0) {
          let favorites = appData.state.products.filter(p => p.fav);
          let favoritesNames = favorites.map(f => f.Name);
          if(favoritesNames.includes(product.Name)) {
            product.fav = true;
          }
        }

        let appendDetailsUrl = (url) => {
          product.url = url;
          completedDetailNameFiles.push(url);
          if(completedDetailNameFiles.length === data.length) {
            detailsDone = true;
            if(namesDone) {
              callback();
            }
          }
        };

        let appendNameUrl = (url) => {
          product.NameSvg = url;
          completedNameFiles.push(url);
          if(completedNameFiles.length === data.length) {
            namesDone = true;
            if(detailsDone) {
              callback();
            }
          }
        };

        helpers.createFile(product.fileDetailsName, product.DetailsSvg, appendDetailsUrl);
        helpers.createFile(product.fileNameName, product.NameSvg, appendNameUrl);
      });
    },
  },
  created() {
    global.IS_APP = !!window.cordova;

    this.showLandingPage(Landing);

    let noNetworkConnection = () => {
      return (navigator.connection && navigator.connection.type == 'none') || !navigator.onLine;
    };

    let onDeviceReady = (isResume) => {

      helpers.initializeDatabase();

      let getDataFromLocalStorage = () => {
        this.showLoader = true;
        this.loadingMessage = 'Loading products from local storage...';
        helpers.readFile('History.svg', (results) => {
            if(results) {
                appData.updateCompanyHistory(results);
                finishReadingFiles();
            } else {
                delete localStorage.lastFetched;
                refreshContent();
            }
        });

        let finishReadingFiles = () => {
            helpers.readFile('Legal.svg', (results) => {
                appData.updateLegal(results);
            });

            let employees = locStor.getEmployees();
            employees.forEach(e => {
                helpers.readFile(e.fileName, (results) => {
                    e.Html = results;
                    appData.updateEmployee(e);
                });
            });

            let products = locStor.getProducts();
            products.forEach((p, index) => {
                let nameDone = false;
                let detailsDone = false;

                let callback = () => {
                    if(nameDone && detailsDone) {
                        if(index === (products.length - 1)) {
                            this.showLoader = false;
                        }
                        console.log(p);
                        appData.updateProduct(p);
                    }
                };

                helpers.readFile(p.fileDetailsName, (results) => {
                    p.DetailsSvg = results;
                    detailsDone = true;
                    callback();
                });

                helpers.readFile(p.fileNameName, (results) => {
                    p.NameSvg = results;
                    nameDone = true;
                    callback();
                });
            });
        };

        appData.updateAllTypes(locStor.getTypes());
      };

      let refreshContent = () => {
        this.showLoader = true;
        this.getUpdatedFilenames()
          .then(response => {
            this.showLoader = false;
            if(!isResume && !response) {
              getDataFromLocalStorage();
            }
            if(response) {
              this.fileNames = response.split('/');
              appData.updateUpdateAlert(true);
              if (!isResume) {
                this.getContentsOfFiles();
              }
            }
        });
      };

      if(noNetworkConnection()) {
        this.showLoader = false;
        getDataFromLocalStorage();
      } else {
        refreshContent();
      }
    };

    if (global.IS_APP) {
      document.addEventListener("deviceready", () => {
        setTimeout(() => {
          navigator.splashscreen.hide();
        },3000);
        onDeviceReady();
      }, false);
    } else {
      onDeviceReady();
    }

    document.addEventListener("resume", () => {
      navigator.connection.getInfo(info => {
        navigator.connection.type = info;
        onDeviceReady(true);
      });
    }, false);
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue